import { render, staticRenderFns } from "./PurchaseCurrentMonthPurchaseNumberDisplayer.vue?vue&type=template&id=258d0ebe"
import script from "./PurchaseCurrentMonthPurchaseNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./PurchaseCurrentMonthPurchaseNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports